import { createAction, props } from '@ngrx/store';
import {
  IPayloadOperationMonitoring,
  IResponseMonitoringDetail,
  IResponseOperationMonitoring,
} from '../../interfaces/monitoring';
import { IMonitoringState } from './monitoring';

export const RETRIVE_MONITORING_OPERATION = createAction(
  '[MONITORING] retrive monitoring operation',
  props<{ payload: IPayloadOperationMonitoring; sigla: string }>()
);

export const RETRIVE_MONITORING_OPERATION_SUCCESS = createAction(
  '[MONITORING] retrive monitoring operation success',
  props<{ operationMonitoring: IResponseOperationMonitoring | null }>()
);

export const RETRIVE_DETAIL_MONITORING_OPERATION = createAction(
  '[MONITORING] retrive detail monitoring operation',
  props<{ idOperazione: number }>()
);

export const RETRIVE_DETAIL_MONITORING_OPERATION_SUCCESS = createAction(
  '[MONITORING] retrive detail monitoring operation success',
  props<{ operationMonitoringDetail: IResponseMonitoringDetail | null }>()
);

export const DOWNLOAD_MONITORING_REPORT = createAction(
  '[MONITORING] - download monitoring report',
  props<{ operazioni: any; rete: string; tab: string; fileName?: string }>()
);

export const DOWNLOAD_MONITORING_REPORT_SAP = createAction(
  '[MONITORING] - download monitoring report SAP',
  props<{ operazioni: any; rete: string; tab: string; fileName?: string }>()
);

export const DOWNLOAD_MONITORING_REPORT_DASHBOARD = createAction(
  '[MONITORING] - download monitoring report DASHBOARD',
  props<{ operazioni: any; rete: string; tab: string; fileName?: string }>()
);

export const RESET_MONITORING_STORE = createAction(
  '[MONITORING] - reset monitoring store'
);
